import { Button, Icon, Typography } from '../../../components'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './download.module.scss'

const Download = ({ message = null, link = null }) =>
  message ? (
    <Button
      variant={'link'}
      component={'a'}
      href={link}
      size={'m'}
      target="_blank"
      download
      className={styles['download-button']}
      rel="noreferrer"
      endIcon={<Icon name="download" color="basic-primary-blue" size={'m'} />}
    >
      <Typography variant={'p10'} color={'basic-primary-blue'} noMargin>
        {message}
      </Typography>
    </Button>
  ) : null

Download.propTypes = {
  message: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  link: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
}

export default Download
